import {
  isCopyableInitiateBizType,
  resolveInitiateBizType
} from '../../utils/workflowCopyRegistry';

const COPYABLE_STATUSES = new Set(['cancelled', 'rejected']);

export { isCopyableInitiateBizType, resolveInitiateBizType };

export function canCopyProcess(process, userId) {
  if (!process || !userId) return false;
  if (!COPYABLE_STATUSES.has(process.status)) return false;
  if (String(process.applicant_id) !== String(userId)) return false;
  const storageBizType = process.biz_type || 'hr_process';
  return Boolean(resolveInitiateBizType(storageBizType, process));
}

function parseProcessFormDataRaw(process) {
  return typeof process.form_data === 'string'
    ? (() => {
      try { return JSON.parse(process.form_data); } catch { return {}; }
    })()
    : (process.form_data || {});
}

export function buildCopyPayload(process, storageBizType) {
  const initiateBizType = resolveInitiateBizType(storageBizType, process);
  if (!initiateBizType) return null;

  const formData = parseProcessFormDataRaw(process);

  return {
    biz_type: initiateBizType,
    storage_biz_type: storageBizType,
    form_data: formData,
    effective_date: process.effective_date || null,
    remark: process.remark || '',
    employee_no: process.employee_no || null,
    company_id: process.company_id || formData.company_id || null,
    process_type: process.process_type || process.claim_type || null
  };
}

export function buildEditPayload(process, storageBizType) {
  const base = buildCopyPayload(process, storageBizType);
  if (!base) return null;
  return {
    ...base,
    draft_id: process.id,
    is_edit: true
  };
}

export const APPROVAL_CENTER_COPY_PATH = '/approval-center?tab=initiated';

export function isOnboardingProcess(process) {
  return process?.process_type === 'onboarding';
}

export function resolveOnboardingEmployeeNo(process) {
  if (!process) return null;
  const fd = typeof process.form_data === 'string'
    ? (() => {
      try { return JSON.parse(process.form_data); } catch { return {}; }
    })()
    : (process.form_data || {});
  return process.employee_no || fd.employee_no || null;
}

export function parseProcessFormData(process) {
  if (!process) return {};
  return parseProcessFormDataRaw(process);
}
